// extracted by mini-css-extract-plugin
module.exports = {"bb-hero-video":"bb-hero-video__3FpxX","with-preview-video":"with-preview-video__dv86y","gradient":"gradient__BF6X_"};